<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Podpisy</div>
            <div class="text-md text-secondary">Automatycznie dodawaj pola na podpisy osób upoważnionych</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-slide-toggle color="primary" [formControl]="signatures">
            {{signatures.value ? "Włączone" : "Wyłączone"}}
        </mat-slide-toggle>
    </div>
</div>